<template>
  <div class="panel-list-page">
    <div class="pl-card">
      <div class="pl-card__header">
        <div class="pl-card__title-wrap">
          <span class="pl-card__icon" aria-hidden="true">
            <CIcon name="iconList"/>
          </span>
          <div>
            <h1 class="pl-card__title">ویژگی اضافی</h1>
            <p class="pl-card__sub">مدیریت ویژگی‌های اضافی محصولات</p>
          </div>
        </div>
        <div class="pl-toolbar">
          <button type="button" class="pl-btn pl-btn--primary" @click="openCreateModal()">
            <CIcon name="iconPlus"/>
            <span>افزودن ویژگی جدید</span>
          </button>
        </div>
      </div>

      <div class="pl-card__body">
        <CDataTableFixed
          :items="items"
          :fields="fields"
          :items-per-page="20"
          hover
          sorter
          pagination
          :noItemsView="{ noItems: 'ویژگی‌ای یافت نشد' }"
        >
          <template #no-items-view>
            <div class="pl-empty">
              <span class="pl-empty__icon" aria-hidden="true">
                <CIcon name="iconList"/>
              </span>
              <p class="pl-empty__title">ویژگی‌ای یافت نشد</p>
              <p class="pl-empty__sub">برای شروع، یک ویژگی اضافی جدید ثبت کنید.</p>
              <button type="button" class="pl-btn pl-btn--primary" @click="openCreateModal()">
                <CIcon name="iconPlus"/>
                <span>افزودن ویژگی جدید</span>
              </button>
            </div>
          </template>

          <template #row="{ item }">
            <td>
              <span class="pl-muted">{{ item.row_id + 1 }}</span>
            </td>
          </template>

          <template #title="{ item }">
            <td>
              <span class="pl-name">{{ item.title }}</span>
            </td>
          </template>

          <template #type="{ item }">
            <td>
              <span class="pl-muted">{{
                type_list.filter(x => x.value == item.type)[0].label
              }}</span>
            </td>
          </template>

          <template #operation="{ item }">
            <td class="pl-ops-cell">
              <div class="pl-ops">
                <button
                  v-if="type_list.filter(x => x.value == item.type)[0].has_multiple_value"
                  type="button"
                  class="pl-btn pl-btn--sm pl-btn--ghost"
                  title="مقادیر ویژگی"
                  @click="goSubCategories(item)"
                >
                  <CIcon name="iconList"/>
                  <span>مقادیر ویژگی</span>
                </button>
                <button
                  type="button"
                  class="pl-icon-btn pl-icon-btn--warn"
                  title="ویرایش"
                  @click="openEditModal(item)"
                >
                  <CIcon name="iconEdit"/>
                </button>
                <button
                  type="button"
                  class="pl-icon-btn pl-icon-btn--danger"
                  title="حذف"
                  @click="delete_dialog(item)"
                >
                  <CIcon name="iconTrash"/>
                </button>
              </div>
            </td>
          </template>
        </CDataTableFixed>
      </div>
    </div>

    <CModal
      :show.sync="form_modal"
      :centered="true"
      size="lg"
      :title="status_form == 0 ? 'افزودن ویژگی جدید' : 'ویرایش ویژگی'"
      @update:show="onFormModalToggle"
    >
      <div class="pl-form">
        <CRow>
          <CCol col="12" md="6">
            <CInput
              v-model="name"
              class="required"
              label="نام"
              placeholder="نام"
            />
          </CCol>
          <CCol col="12" md="6">
            <CSelect
              :value.sync="type"
              class="required"
              :options="type_list"
              label="نوع"
            />
          </CCol>
          <CCol col="12">
            <CInput
              v-model="summary"
              class="required"
              label="متن نمایشی"
              placeholder="متن نمایشی"
            />
          </CCol>
          <CCol v-if="!type_list.filter(x => x.value == type)[0].has_multiple_value" col="12" md="6">
            <CInput
              v-model="price"
              class="required"
              label="مبلغ اضافی"
              placeholder="مبلغ اضافی"
            />
          </CCol>
        </CRow>
      </div>
      <template #footer>
        <button type="button" class="pl-btn pl-btn--ghost" @click="closeFormModal()">انصراف</button>
        <button type="button" class="pl-btn pl-btn--primary" @click="login()">
          <CIcon name="iconCheck"/>
          <span>{{ status_form == 0 ? 'ثبت ویژگی' : 'ذخیره تغییرات' }}</span>
        </button>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "@/api/http";
import {bus} from "../../../main";


export default {
  name: 'Login',
  data() {
    return {
      form_modal: false,
      confirm_delete_name:new Date().getTime()+"_"+this.$vnode.tag,

      name: '',
      type: 1,
      type_list:[
          {label:'چک باکس',value:1,has_multiple_value:false},
          {label:'منو کشویی',value:2,has_multiple_value:true},
          {label:'دکمه رادیویی',value:3,has_multiple_value:true}
      ],

      summary:'',
      price:'0',
      items: [],
      fields: [
        {key: 'row',label: '#', _style: 'width:10%'},
        {key: 'title',label: 'نام', _style: 'width:10%'},
        {key: 'type',label: 'نوع', _style: 'width:10%'},
        {key: 'operation', _style: 'width:40%;'},
      ],
      status_form: 0
    }
  }, mounted() {
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == 'true') {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
    this.get_categories();
  }, watch: {},
  methods: {
    openCreateModal() {
      this.cancel_form();
      this.form_modal = true;
    },
    openEditModal(item) {
      this.editDetails(item);
      this.form_modal = true;
    },
    closeFormModal() {
      this.form_modal = false;
      this.cancel_form();
    },
    onFormModalToggle(show) {
      if (!show) {
        this.cancel_form();
      }
    },
    cancel_form() {
      this.name = '';
      this.type = 1;
      this.summary = '';
      this.price = '0';
      this.status_form = 0;
    },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    editDetails(item) {
      this.name = item.title;
      this.summary = item.summary;
      this.type = item.type;
      this.status_form = item.id;
if(item.type==1){
  this.price = item.values[0].price
}
    },
    get_categories() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/product/get_additional_options', formData, {}).then(function (response) {

        var content_cats = response.data;

        self.items = content_cats.tags.map((item, row_id) => {
          return {...item, row_id}
        });

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    goSubCategories(item) {
      this.$router.push({path: '/dashboard/products/additional-options-values/' + item.id});
    },
    login() {


      let self = this;
      const formData = new FormData()
      let url;
      if (this.status_form == 0) {
        url = "/api/admin/product/add_additional_option";
      } else {
        url = "/api/admin/product/update_additional_option";
        formData.append('id', this.status_form)

      }

      formData.append('name', this.name);
      formData.append('type', this.type);
      formData.append('summary', this.summary);
      formData.append('price', this.price);



      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;
        self.name = '';
        self.form_modal = false;
        self.get_categories();

      })

          .catch(function (error) {

            console.log(error);
          });

    },
    delete_dialog(item) {
      this.$root.modal_component.show_confirm_modal('اخطار', "آیا مایل به حذف این ردیف هستید؟", ['تایید'], this.confirm_delete_name);
      this.status_form = item.id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/product/delete_additional_option";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;
        self.get_categories();

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },


  }
}


</script>
